import { render, staticRenderFns } from "./safetyResponsibilityBook.vue?vue&type=template&id=d881c206&scoped=true"
import script from "./safetyResponsibilityBook.vue?vue&type=script&lang=js"
export * from "./safetyResponsibilityBook.vue?vue&type=script&lang=js"
import style0 from "./safetyResponsibilityBook.vue?vue&type=style&index=0&id=d881c206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d881c206",
  null
  
)

export default component.exports